<template>
    <div class="inspection-page">
      <div class="left-form" ref="madeForm">
        <avue-form ref="AvueForm" :option="formOption" v-model="detailForm" @submit="submit"></avue-form>
        
        <!-- 物资申请明细表格 -->
        <div class="storage-point-section">
          <div class="section-title">
            <span>物资申请明细</span>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addMaterialItem">添加物资</el-button>
          </div>
          <el-table :data="materialApplicationList" border style="width: 100%" v-if="materialApplicationList.length > 0">
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="物资" prop="materialName" min-width="200">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.materialCode"
                  placeholder="请选择物资"
                  filterable
                  style="width: 100%"
                  @change="handleMaterialSelectChange(scope.row, $event)"
                >
                  <el-option
                    v-for="item in materialOptions"
                    :key="item.materialCode"
                    :label="`${item.materialName} (${item.materialCode})`"
                    :value="item.materialCode"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="物资名称" prop="materialName" min-width="150" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.materialName || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="物资类型" prop="materialType" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.materialType || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="当前库存" prop="currentStock" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.currentStock || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请数量" prop="applyQuantity" width="150">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.applyQuantity"
                  :min="0.01"
                  :max="999999"
                  :precision="2"
                  style="width: 100%"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="单位" prop="unit" width="100" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.unit || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" icon="el-icon-delete" @click="removeMaterialItem(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="empty-tip">请添加至少一个物资</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { disposeDetail, rulesInput } from '@/basic-common/util/common.js';
  import { getList as getMaterialList } from '../../y-materials/api';
import { supplyAppInsert } from '../api';
  
  export default {
    props: {
      materialApplicationRow: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        detailForm: {
          priority: '',
          emergencyEventNumber: '',
          emergencyEventName: '',
          emergencyPlanId: '',
          longitude: '',
          latitude: '',
          applicationTime: '',
          remark: ''
        },
        materialApplicationList: [],
        materialOptions: [],
        formOption: {
          ...this.$store.state.formOption,
          menu: false,
          span: 24,
          submitBtn: true,
          emptyBtn: true,
          edit: true,
          column: [
            {
              label: '响应等级',
              prop: 'priority',
              type: 'select',
              dicData: [
                { label: '紧急', value: 1 },
                { label: '一级', value: 2 },
                { label: '二级', value: 3 },
                { label: '三级', value: 4 },
              ],
              placeholder: '请选择响应等级',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '应急事件编码',
              prop: 'emergencyEventNumber',
              type: 'input',
              maxlength: 100,
              disabled: true,
              placeholder: '请输入应急事件编码',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '应急事件名称',
              prop: 'emergencyEventName',
              type: 'input',
              maxlength: 200,
              disabled: true,
              placeholder: '请输入应急事件名称',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '应急预案ID',
              prop: 'emergencyPlanId',
              type: 'number',
              disabled: true,
              placeholder: '请输入应急预案ID',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '经度',
              prop: 'longitude',
              type: 'input',
              maxlength: 20,
              placeholder: '请输入经度',
              rules: [
                { pattern: /^-?(\d{1,2}|1[0-7]\d|180)\.?\d*$/, message: '请输入正确的经度范围(-180到180)', trigger: 'blur' }
              ],
              span: 12,
            },
            {
              label: '纬度',
              prop: 'latitude',
              type: 'input',
              maxlength: 20,
              placeholder: '请输入纬度',
              rules: [
                { pattern: /^-?([1-8]?\d|90)\.?\d*$/, message: '请输入正确的纬度范围(-90到90)', trigger: 'blur' }
              ],
              span: 12,
            },
            {
              label: '申请时间',
              prop: 'applicationTime',
              type: 'datetime',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              placeholder: '请选择申请时间',
              rules: rulesInput(2),
              span: 12,
            },
            {
              label: '备注',
              prop: 'remark',
              type: 'textarea',
              maxlength: 500,
              rows: 4,
              placeholder: '请输入备注',
              span: 24,
            },
          ],
        },
      };
    },
    mounted () {
      this.init();
      this.loadMaterialOptions();
    },
    methods: {
      init () {
        console.log(`👽👽👽👽👽👽👽`,this.materialApplicationRow)
        this.detailForm = {
          emergencyEventNumber: this.materialApplicationRow.eventNumber,
          emergencyEventName: this.materialApplicationRow.eventName,
          emergencyPlanId:this.materialApplicationRow.id,
        }
        disposeDetail(this.$refs.madeForm);
      },
      // 加载物资选项
      async loadMaterialOptions () {
        try {
          const res = await getMaterialList({
            page: 1,
            size: 1000,
            status: 1, // 只获取有效的物资
          });
          if (res.data && res.data.data && res.data.data.records) {
            this.materialOptions = res.data.data.records;
            const materialColumn = this.formOption.column.find(col => col.prop === 'materialCode');
            if (materialColumn) {
              materialColumn.dicData = this.materialOptions.map(item => ({
                label: `${item.materialName} (${item.materialCode})`,
                value: item.materialCode,
                ...item
              }));
            }
          }
        } catch (error) {
          console.error('加载物资列表失败:', error);
          this.$message.error('加载物资列表失败');
        }
      },
      // 处理物资选择变化
      handleMaterialSelectChange (row, materialCode) {
        const material = this.materialOptions.find(item => item.materialCode === materialCode);
        if (material) {
          row.materialName = material.materialName;
          row.materialType = material.materialType;
          row.unit = material.unit || '';
          // 可以在这里获取当前库存
          // row.currentStock = ...;
        }
      },
      // 添加物资申请项
      addMaterialItem () {
        this.materialApplicationList.push({
          materialCode: '',
          materialName: '',
          materialType: '',
          applyQuantity: 0,
          unit: '',
          currentStock: 0,
          remark: '',
        });
      },
      // 移除物资申请项
      removeMaterialItem (index) {
        this.materialApplicationList.splice(index, 1);
      },
      toSubmit(){
        this.$refs.AvueForm.submit();
      },
      // 提交表单
      submit (form, done) {
        this.$refs.AvueForm.validate((valid) => {
          if (!valid) {
            done();
            return false;
          }
          // 验证物资申请明细
          if (!this.materialApplicationList || this.materialApplicationList.length === 0) {
            this.$message.warning('请至少添加一个物资申请明细');
            done();
            return false;
          }
  
          // 验证物资申请明细完整性
          for (let i = 0; i < this.materialApplicationList.length; i++) {
            const item = this.materialApplicationList[i];
            if (!item.materialCode) {
              this.$message.warning(`请选择第${i + 1}个物资`);
              done();
              return false;
            }
            if (!item.applyQuantity || item.applyQuantity <= 0) {
              this.$message.warning(`请输入第${i + 1}个物资的申请数量`);
              done();
              return false;
            }
          }
  
          // 构建提交数据
          const submitData = {
            ...this.detailForm,
            EmergencySupplyAExtList: this.materialApplicationList.map(item => ({
              materialCode: item.materialCode,
              materialName: item.materialName,
              materialType: item.materialType,
              applyQuantity: item.applyQuantity,
              unit: item.unit || '',
              currentStock: item.currentStock || 0,
              remark: item.remark || '',
            })),
          };
  
          
        // 调用接口提交
        supplyAppInsert(submitData).then((res) => {
            if (res.data && res.data.code === 200) {
              this.$message.success('操作成功');
              this.resetForm();
              done();
              this.$emit('submitData', submitData, done);
            } else {
  
            }
          })

          // 触发提交事件，由父组件处理
          
        });
      },
      // 重置表单
      resetForm () {
        this.$refs.AvueForm.resetForm();
        this.detailForm = {
          priority: '',
          emergencyEventNumber: '',
          emergencyEventName: '',
          emergencyPlanId: '',
          longitude: '',
          latitude: '',
          applicationTime: '',
          remark: ''
        };
        this.materialApplicationList = [];
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-form__menu {
    display: none;
  }
  .inspection-page {
    display: flex;
    padding: 20px;
    gap: 20px;
    background-color: #fff;
  }
  .left-form {
    flex: 1;
  }
  .storage-point-section {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
  }
  .empty-tip {
    text-align: center;
    color: #909399;
    padding: 40px 0;
  }
  </style>